import { createStrictContext as i } from "../../util/context/createStrictContext.js";
import { useState as s } from "react";
import { jsx as d } from "react/jsx-runtime";
const [a, m] = i("DataGrid", {
  showGrid: !0,
  setShowGrid: () => {
  }
}), u = (t) => {
  const {
    children: r
  } = t, [o, e] = s(!0);
  return /* @__PURE__ */ d(a, {
    value: {
      showGrid: o,
      setShowGrid: e
    },
    children: r
  });
};
export {
  u as DataGridProvider,
  m as useDataGridContext
};
//# sourceMappingURL=DataGridContext.js.map
